import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalInstanceComponent } from './external-instance.component';
import { ExternalInstanceRoutingModule } from './external-instance-routing.module';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {TableModule} from 'src/app/table/table.module';
import { IconsModule } from '../../icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import {MatMenuModule} from '@angular/material/menu';
import { ExternalInstanceDetailsComponent } from './external-instance-details/external-instance-details.component';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { CreateInstanceComponent } from './create-instance/create-instance.component';
import { ErrorModule } from 'src/app/components/error/error.module';
@NgModule({
  declarations: [
    ExternalInstanceComponent,
    ExternalInstanceDetailsComponent,
    CreateInstanceComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    ExternalInstanceRoutingModule,
    TableModule,
    IconsModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule,
    MatInputModule,
    ErrorModule,
    SidenavHeaderModule,
    ClipboardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
    PaginatorModule,
    MatTooltipModule,
    DefaultFilterModule,
    ToolbarModule,
    MatMenuModule,
    InstanceDetailsModule,
    SearchFilterModule
  ]
})
export class ExternalInstanceModule { }
